import fetchData from "./fetchData";

//get experience based on people

//post insights
export async function getInsights(country) {
    return await fetchData(undefined, `query getInsights($country: String) {
  countries(where: {slug: [$country]}) {
    nodes {
      insights(first: ${screenWidth.matches ? 3 : 1000}, where: {orderby: {field: DATE, order: DESC}}) {
        nodes {
          title
          uri
          date
          postTypeInsights {
            insightsPhoto {
              sourceUrl(size: MEDIUM_LARGE)
            }
          }
          insightCategories {
            nodes {
              name
            }
          }
          translations {
            href
            locale
          }
          translated {
              terms {
                    nodes {
                      name
                    }
                  }
            locale {
              locale
            }
            postTypeInsights {
              insightsPhoto {
                sourceUrl
              }
            }
            insightCategories {
              nodes {
                name
              }
            }
            title
            uri
            date
            terms {
              nodes {
                name
              }
            }
          }
        }
      }
    }
  }
}`, {country})
}

export async function getNewCareers(country) {
    return await fetchData(undefined, `query getCareers {
        careers(
            first: 100
            where: { stati: [PUBLISH], orderby: { field: DATE, order: DESC } }
        ) {
            nodes {
                status
                postTypeCareer {
                    careersOffice
                    careersPractice
                    careersHidden
                    studentPractice
                }
                locale {
                    locale
                }
                title
                uri
                translations {
                    href
                    locale
                }
                translated {
                    status
                    postTypeCareer {
                        careersHidden
                        careersOffice
                        careersPractice
                        studentPractice
                    }
                    title
                    uri
                    locale {
                        locale
                    }
                }
            }
        }
    }
`, {country});
}

//careers (translations - done)
export async function getCareers(country) {
    return await fetchData(undefined, `query getCareers($country: String) {
  countries(where: {slug: [$country]}) {
    nodes {
      careers(first: 100) {
        nodes {
          postTypeCareer {
            careersHidden
            careersOffice
            careersPractice
          }
          title
          uri
          translations {
            href
            locale
          }
          translated {
            postTypeCareer {
              careersHidden
              careersPractice
              careersOffice
            }
            title
            uri
            locale {
              locale
            }
          }
        }
      }
    }
  }
}
`, {country});
}


//post contacts (translations done)
export async function getContacts(country) {
    return await fetchData(undefined, `query getContacts($country: String) {
  countries(where: {slug: [$country]}) {
    nodes {
         contacts(first: 100, where: {stati: PUBLISH}) {
        nodes {
          title
          postTypeContacts {
            contactAddress
            contactLinkedin
            contactMap {
              target
              title
              url
            }
            contactFind {
              target
              title
              url
            }
            contactEamils {
              email
            }
            contactPhones {
              phone
            }
            contactPhoto {
              sourceUrl
            }
          }
          translated {
            title
          
            postTypeContacts {
              contactAddress
              contactLinkedin
              contactMap {
                target
                title
                url
              } 
               contactFind {
              target
              title
              url
            }
              contactEamils {
                email
              }
              contactPhones {
                phone
              }
              contactPhoto {
                sourceUrl
              }
            }
            locale {
              locale
            }
          }
        }
      }
    }
  }
}`, {country})
}

export async function getPeopleCount(title) {
    return await fetchData(undefined, `query getPersonsCount($title: String) {
  services(where: {title: $title}, first: 100) {
    nodes {
      postTypeService {
        servicesRelatedPeople {
          ... on Person {
            title
            countries {
              nodes {
                slug
              }
            }
          }
        }
      }
      title
    }
  }
}`, {title})
}

export async function getInnerArticlePeople() {
    return await fetchData(undefined, `query getArticlePeople {
  persons(first: 100) {
    nodes {
      postTypePersons {
        personInnerArticle {
          ... on Insight {
            id
            title
          }
        }
        personsLinkedin
        personsButtonText
        personsPhoto {
          sourceUrl
        }
      }
      uri
      title
      translations {
        href
        locale
      }
      terms {
        nodes {
          slug
          name
        }
      }
    }
  }
}`)
}

export async function getPracticeAreas() {
    return await fetchData(undefined, `query getArticlePeople {
      experiencePracticeAreas(first: 100) {
        nodes {
          slug
          name
        }
      }
    }
  `)
}

//changing text query
export async function getField(state = 'text', page_id, templateName, graphQLName, fieldGroup, office) {
    return await fetchData(undefined, `query MyQuery($page_id: ID!) {
         page(id: $page_id, idType: DATABASE_ID) {
             template {
             ... on Template_${templateName} {
                     templateName
                     ${graphQLName} {
                         ${fieldGroup} {
                             ${state === 'text' ? `${office}` : state === 'img' ? `${office}{
                                sourceUrl
                             }` : `${state === 'repeater' ? `${office}` :
        state === 'repeater-carousel' ? `${office}{
                                sourceUrl
                             }` :
            state === 'carousel-2'
                ? `${office}1 ${office}2`
                :
                state === 'repeater-2'
                    ? `${office}1 ${office}2`
                    :
                    state === 'repeater-2-philosophy'
                        ? `${office}1 ${office}2`
                        :
                        state === 'repeater-policy-3'
                            ? `${office}1 ${office}3`
                            :
                            //office 3
                            //office 4
                            state === 'repeater-3'
                                ? `${office}1 ${office}2{ sourceUrl } ${office}3{ ${office}${office.charAt(0).toUpperCase() + office.slice(1)}1 ${office}${office.charAt(0).toUpperCase() + office.slice(1)}2 {target, title, url} }`
                                :
                                state === 'group-3' ? `${office}1 ${office}2 ${office}3 ` :
                                    state === 'repeater-m-2' ? `${office}1 ${office}2 { ${office}${office.charAt(0).toUpperCase() + office.slice(1)}{target, title, url} }` : ''
    }`}
                         }
                     }
                 }
             }     
         }
     }
  `, {page_id})
}

//get post type expertise fields
export async function getPostField(state = 'text', page_id, postTypeName, fieldGroup, office) {
    return await fetchData(undefined, `query MyQuery($page_id: ID!) {
      ${postTypeName}(id: $page_id, idType: DATABASE_ID) {
        postType${postTypeName.charAt(0).toUpperCase() + postTypeName.slice(1)} {
          ${fieldGroup} {
            ${state === 'text' ? `${office}`
        : `${state === 'img' ? `${office}`
            : `${state === 'repeater' ? `${office}`
                : `${state === 'repeater-2' ? `${office}1 ${office}2`
                    :
                    state === 'repeater-4' ? `${office}1 ${office}2 ${office}3 ${office}4` : ''}`}`}`}
          }
        }
      }
    }`, {page_id})
}